<div class="flex justify-between items-center">
  <div class="flex align-center">

    <span matSnackBarLabel>
      {{data.message}}
    </span>
    @if (data.action ) {
      <span matSnackBarActions>
        <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">{{data.action}}</button>
      </span>
    }
    
  </div>
  <span matSnackBarDismiss class="flex items-end">
    <button class="rounded-none shadow-sm p-1" (click)="snackBarRef.dismiss()">
      <mat-icon class="text-white">close</mat-icon>
    </button>
  </span>

</div>